import React from 'react';
import PropTypes from 'prop-types';

import { AButtonIndicator } from '../atoms';

export default function MPagination({
	nextLabel,
	backLabel,
	previousButtonLocked,
	nextButtonLocked,
	onBack,
	onNext,
	className,
}) {
	return (
		<div className={`m-pagination ${className}`}>
			<AButtonIndicator
				value={backLabel}
				icon="arrowLeft"
				iconClass="small"
				onClick={onBack}
				disabled={previousButtonLocked}
			/>
			<AButtonIndicator
				value={nextLabel}
				icon="arrowRight"
				iconClass="small"
				className="right"
				onClick={onNext}
				disabled={nextButtonLocked}
			/>
		</div>
	);
}

MPagination.propTypes = {
	nextLabel: PropTypes.string.isRequired,
	backLabel: PropTypes.string.isRequired,
	previousButtonLocked: PropTypes.bool,
	nextButtonLocked: PropTypes.bool,
	onBack: PropTypes.func,
	onNext: PropTypes.func,
	className: PropTypes.string,
};

MPagination.defaultProps = {
	previousButtonLocked: false,
	nextButtonLocked: false,
	onBack: undefined,
	onNext: undefined,
	className: '',
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.pagination.js